// extracted by mini-css-extract-plugin
module.exports = {"heading-wrapper":"_9e1425b4d3--heading-wrapper--g856s","items-wrapper":"_9e1425b4d3--items-wrapper--xd7Nx"};